import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { getLoggedInUser, IAuthenticationState } from '@app/stores';
import { map } from 'rxjs/operators';
import { UserAbilityService } from '@app/services/user-ability.service';

@Injectable({ providedIn: 'root' })
export class AtLeastAdminGuard {
  private router = inject(Router);
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private userAbilityService = inject(UserAbilityService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationStore.pipe(select(getLoggedInUser)).pipe(
      map((currentUser) => {
        if (!currentUser) {
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          return false;
        }

        this.userAbilityService.setUser(currentUser);
        const permission = route.data?.permission || 'view-admin-features';
        if (!this.userAbilityService.can(permission, 'navigation')) {
          return this.router.parseUrl(this.userAbilityService.getDefaultDashboard(currentUser));
        }

        return true;
      })
    );
  }
}
